import React from 'react';

const ThirdPartyComponentsRoutes = [
	{
		path: '/documentation/third-party-components/formsy',
		component: React.lazy(() => import('./formsy/FormsyDoc'))
	},
	{
		path: '/documentation/third-party-components/datatables/react-table',
		component: React.lazy(() => import('./datatables/react-table/ReactTableDoc'))
	},
	{
		path: '/documentation/third-party-components/google-map-react',
		component: React.lazy(() => import('./google-map-react/GoogleMapReactDoc'))
	},
];

export default ThirdPartyComponentsRoutes;
